exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb[data-v-e2b6cf46]{margin-top:10px}.breadcrumb i[data-v-e2b6cf46]{padding-right:10px}.breadcrumb a[data-v-e2b6cf46]{color:#485767}.left-list[data-v-e2b6cf46]{float:left;width:80%}.right-list[data-v-e2b6cf46]{justify-content:flex-end}", ""]);

// exports
